import React from 'react';

interface ToggleButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active: boolean;
  shape?: 'pill' | 'segment';
  children: React.ReactNode;
}

// Shared base for the filter pills and the segmented control, which previously
// duplicated the same padding/size/weight with slightly different corners.
const ToggleButton: React.FC<ToggleButtonProps> = ({
  active,
  shape = 'pill',
  children,
  className = '',
  ...rest
}) => (
  <button
    type="button"
    aria-pressed={active}
    className={`inline-flex min-h-11 items-center justify-center px-3 py-2 text-xs font-medium transition-colors ${
      shape === 'pill' ? 'rounded-full border' : 'rounded-lg'
    } ${
      active
        ? `bg-inverse text-inverse-content ${shape === 'pill' ? 'border-inverse' : ''}`
        : `text-content-secondary hover:bg-surface-sunken ${shape === 'pill' ? 'bg-surface-raised border-line' : ''}`
    } ${className}`}
    {...rest}
  >
    {children}
  </button>
);

export default ToggleButton;
